import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import Modal from '../modal/Modal';
import Expenses from '../../units/sales/expense/Expenses';

const ExpenseSearchButton = ({ getRowData, title, size }) => {
  const [showModal, setShowModal] = useState(false);

  const onSelectRow = (row) => {
    if (getRowData) getRowData(row);
    setShowModal(false);
  };

  const button = (
    <Button
      type="button"
      outline
      onClick={() => setShowModal(true)}
      className="mb-2"
      style={{ zIndex: 0 }}
      size={size}
    >
      <i className="fa fa-files-o" /> {title}
    </Button>
  );

  const modal = (
    <Modal
      show={showModal}
      title={title}
      body={<Expenses getRowData={onSelectRow} showOnModal />}
      onClickClose={() => setShowModal(false)}
      size="xl"
    />
  );

  return (
    <>
      {modal}
      {button}
    </>
  );
};

ExpenseSearchButton.propTypes = {
  title: PropTypes.string.isRequired,
  getRowData: PropTypes.func,
  size: PropTypes.string,
};

ExpenseSearchButton.defaultProps = {
  getRowData: null,
  size: 'md',
};

export default ExpenseSearchButton;
